import React from 'react';
import {
    FormControl,
    FormHelperText,
    InputLabel,
    makeStyles,
    MenuItem,
    Select,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { LEVERANDOR_REGIONS } from '@klp/leverandor/types';

const useStyles = makeStyles((theme) => ({
    formField: {
        '& .MuiTypography-root': {
            color: theme.palette.text.primary,
        },
        '& .Mui-disabled': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
    },
}));

export interface RegionSelectProps {
    value: LEVERANDOR_REGIONS | undefined;
    touched?: boolean;
    error?: string;
    onChange: (region: LEVERANDOR_REGIONS) => void;
}

const regionOptions: Array<{ value: LEVERANDOR_REGIONS; label: string }> = [
    {
        value: LEVERANDOR_REGIONS.Oslo,
        label: 'leverandor.createLeverandor.region.oslo',
    },
    {
        value: LEVERANDOR_REGIONS.Trondheim,
        label: 'leverandor.createLeverandor.region.trondheim',
    },
    {
        value: LEVERANDOR_REGIONS.Sverige,
        label: 'leverandor.createLeverandor.region.sverige',
    },
    {
        value: LEVERANDOR_REGIONS.Danmark,
        label: 'leverandor.createLeverandor.region.danmark',
    },
    {
        value: LEVERANDOR_REGIONS.Europa,
        label: 'leverandor.createLeverandor.region.europa',
    },
];

export const RegionSelect: React.FC<RegionSelectProps> = ({
    value,
    touched,
    error,
    onChange,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <FormControl
            fullWidth={true}
            variant="outlined"
            error={touched && !!error}
            required={true}
        >
            <InputLabel id="region-select-label" className={classes.formField}>
                {t('leverandor.createLeverandor.region.label')}
            </InputLabel>
            <Select
                labelId="region-select-label"
                value={value ?? ''}
                onChange={(event) => {
                    onChange(event.target.value as LEVERANDOR_REGIONS);
                }}
                label={t('leverandor.createLeverandor.region.label')}
            >
                {regionOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                        {t(option.label)}
                    </MenuItem>
                ))}
            </Select>
            {touched && error && <FormHelperText>{error}</FormHelperText>}
        </FormControl>
    );
};
